import type { BridgeType } from "./bridgeConfig";
import { WaitingModal } from "../WaitingModal";

interface BridgeWaitingModalProps {
  isOpen: boolean;
  onClose: () => void;
  txHash?: string;
  bridgeType?: BridgeType;
}

export function BridgeWaitingModal({ isOpen, onClose, txHash, bridgeType }: BridgeWaitingModalProps) {
  const title =
    bridgeType === "withdraw" ? "Withdrawing to Ethereum..." : "Bridging tokens to Aztec...";

  const description =
    bridgeType === "withdraw"
      ? "The withdrawal can take up to 15 minutes. You can stay or close the modal and we will notify you when the transaction is complete."
      : "The transaction can take up to 15 minutes. You can stay or close the modal and we will notify you when the transaction is complete.";

  return (
    <WaitingModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      txHash={txHash}
      showCountdown={true}
      countdownDuration={15 * 60}
    />
  );
}
